import axios from 'axios';
import cookie from 'js-cookie';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
    withCredentials: true,
    headers: {
        'X-XSRF-TOKEN': cookie.get('XSRF-TOKEN'),
    },
});

/**
 * Fetch pending field worker registration requests for a project.
 * @param {string} projectId
 * @returns {Promise<Array>}
 */
export const getPendingFieldWorkerRequests = async (projectId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/field-worker-requests/project/${projectId}/pending`,
            authHeaders()
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching field worker requests:', error);
        throw error;
    }
};

/**
 * Create a field worker registration request.
 * @param {Object} data
 * @param {string} data.projectId
 * @param {string} data.fieldWorkerFirstName
 * @param {string} data.fieldWorkerLastName
 * @param {string} data.fieldWorkerPhoneNumber
 * @returns {Promise<Object>}
 */
export const createFieldWorkerRequest = async (data) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/field-worker-requests`,
            {
                projectId: data.projectId,
                fieldWorkerFirstName: data.fieldWorkerFirstName,
                fieldWorkerLastName: data.fieldWorkerLastName,
                fieldWorkerPhoneNumber: data.fieldWorkerPhoneNumber,
                requestType: 'register',
            },
            {
                ...authHeaders(),
                headers: {
                    ...authHeaders().headers,
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error creating field worker request:', error);
        throw error;
    }
};

/**
 * Delete a pending field worker registration request.
 * @param {string} requestId
 * @returns {Promise<void>}
 */
export const deleteFieldWorkerRequest = async (requestId) => {
    try {
        await axios.delete(`${API_BASE_URL}/field-worker-requests/${requestId}`, authHeaders());
    } catch (error) {
        console.error('Error deleting field worker request:', error);
        throw error;
    }
};

/**
 * Approve or reject a field worker registration request.
 * @param {string} requestId
 * @param {'approve' | 'reject'} decision
 * @returns {Promise<Object>}
 */
export const approveOrRejectFieldWorkerRequest = async (requestId, decision) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}/field-worker-requests/approve-reject`,
            { requestId, decision },
            {
                ...authHeaders(),
                headers: {
                    ...authHeaders().headers,
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error approving/rejecting field worker request:', error);
        throw error;
    }
};
